import { AspBillsRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAspBills() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);

  // Called once per Status tab ('open' | 'paid') — callers keep the returned lists.
  async function fetchAspBills(params: AspBillsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchAspBills(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, fetchAspBills };
}
